import $ from 'jquery'
import size from './size'

const accordion = () => {

    const $titles = $('.accordion__title')
    const $content = $('.accordion__content')

    // prevent 'jumping' on the first click in chrome mobile 
    if (size.isMobile()) {
        // $content.show()
        //$content.hide()
    }
    $content.show()
    $content.hide()

    $titles.on('click', function (e) {


        // block option in data attr
        const closeOthers = $(this).parents('.accordion')[0].dataset.closeOthers

        if (closeOthers === 'true') {

            $content.each((index, el) => {

                const thisParent = $(this).parents('.accordion')[0]
                const elParent = $(el).parents('.accordion')[0]

                // seperate between diferent accordions and prevent double slide on the current element
                if ((this !== $(el).prev('.accordion__title')[0]) && (thisParent === elParent)) {
                    $(el).slideUp()
                    $(el).prev().removeClass('accordion--active')
                    $(el).prev().children('.minus-sign').removeClass('minus-sign--active')
                    $(el).prev().children('.plus-sign').addClass('plus-sign--active')
                }

            })
        }

        $(this).toggleClass('accordion--active')

        $(this).next('.accordion__content').slideToggle();

    })

}

export default accordion